<template>
    <div>
      <label v-if="label" class="form-label">{{ label }}:</label>
      <div class="relative p-0" :class="{ error: error }">
        <input ref="file" type="file" :accept="accept" class="hidden" @change="change" />
        <div v-if="!modelValue?.upload && !modelValue?.url" class="p-2">
          <button type="button" class="btn-primary font-normal text-xs px-6 py-2.5" @click="browse"><font-awesome-icon icon="fa-image-portrait" class="mr-2" /> Procurar</button>
        </div>
        <div v-else class="flex items-center justify-center p-2">
          <div class="overflow-hidden">
            <cropper ref="cropper" v-if="this.crop && this.modelValue.upload" :src="photoSelected" @change="changeCrop" />
            <img v-else :src="photoSelected" class="w-52" />
            <div>{{ photoNameSelected }}</div>
            <span class="text-gray-500 text-xs">({{ photoFileSelected }})</span>
          </div>
          <button type="button" class="absolute right-0 top-0 py-1 w-[30px] text-center text-white text-sm font-medium bg-red-500 hover:bg-red-700 rounded-sm" @click="remove"><font-awesome-icon icon="fa-xmark" /></button>
          <button type="button" class="absolute right-0 top-10 py-1 w-[30px] text-center text-white text-sm font-medium bg-blue-500 hover:bg-blue-700 rounded-sm" @click="changePhoto"><font-awesome-icon icon="fa-rotate" /></button>
        </div>
      </div>
      <div v-if="error" class="form-error">{{ error }}</div>
    </div>
  </template>

  <script>
  import { Cropper } from 'vue-advanced-cropper'
  import 'vue-advanced-cropper/dist/style.css';

  export default {
    components: {
      Cropper,
    },
    props: {
      modelValue: Object,
      label: String,
      accept: {
        type: String,
        default: 'image/*',
      },
      crop: {
        type: Boolean,
        default: true,
      },
      error: String,
    },
    emits: ['update:modelValue'],
    watch: {
      modelValue(value) {
        if (!value) {
          this.$refs.file.value = ''
        }
      },
    },
    computed: {
      photoSelected: function() {
        if(this.modelValue.upload) {
          return URL.createObjectURL(this.modelValue.upload);
        } else if(this.modelValue.url) {
          return this.modelValue.url;
        }
        return '#';
      },
      photoNameSelected: function() {
        if(this.modelValue.upload) {
          return this.modelValue.upload.name;
        } else if(this.modelValue.url) {
          return this.modelValue.name;
        }
        return '';
      },
      photoFileSelected: function() {
        if(this.modelValue.upload) {
          return this.filesize(this.modelValue.upload.size);
        } else if(this.modelValue.url) {
          return this.filesize(this.modelValue.size);
        }
        return '';
      },
    },
    methods: {
      filesize(size) {
        var i = Math.floor(Math.log(size) / Math.log(1024))
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
      },
      browse() {
        this.$refs.file.click()
      },
      change(e) {
        let model = this.modelValue;
        model.upload = e.target.files[0];
        this.$emit('update:modelValue', model)
      },
      changeCrop() {
        let model = this.modelValue;
        const { canvas } = this.$refs.cropper.getResult();
        if (canvas) {
          canvas.toBlob(async blob => {
            model.upload_crop = blob;
            this.$emit('update:modelValue', model);
          }, "image/png");
        }
      },
      remove() {
        let model = this.modelValue;
        model.upload = null;
        model.url = null;
        this.$emit('update:modelValue', model)
      },
      changePhoto() {
        this.browse();
      },
    },
  }
  </script>
